// Frequency (F4) read-back: once someone slides, the chosen word goes into the sentence
// ("I often assume good things won't last..."). An explicit map by item id says where.
// The anchor is found in the live text, so if a question is ever reworded and the anchor
// is gone, we fall back to showing the word as a chip instead of a broken sentence.

/** Where the frequency word goes. null = the sentence doesn't take it: show a chip. */
export const READBACK_ANCHORS: Record<string, { anchor: string; leading: boolean } | null> = {
  F7: { anchor: "I ", leading: true },
  F9: { anchor: "I ", leading: true },
  C6: { anchor: "I ", leading: true },
  G3: { anchor: "I ", leading: true },
  G5: { anchor: "I ", leading: true },
  G15: { anchor: "I ", leading: true },
  G9: { anchor: ", I ", leading: false },
  G19: { anchor: "People ", leading: true },
  // Pending Taylor: these sentences don't take the word ("I can rest...", "People in pain tend to...").
  F13: null,
  G13: null,
};

export interface ReadbackParts {
  before: string;
  word: string;
  after: string;
}

/** Splits the sentence around the inserted word, or returns null to show a chip instead. */
export function readbackParts(itemId: string, text: string, label: string): ReadbackParts | null {
  const rule = READBACK_ANCHORS[itemId];
  if (!rule) return null;
  const at = rule.leading ? (text.startsWith(rule.anchor) ? 0 : -1) : text.indexOf(rule.anchor);
  if (at < 0) return null;
  const cut = at + rule.anchor.length;
  return { before: text.slice(0, cut), word: label.toLowerCase(), after: " " + text.slice(cut) };
}

/** The full read-back sentence, for tests and screen readers. */
export function readbackSentence(itemId: string, text: string, label: string): string | null {
  const p = readbackParts(itemId, text, label);
  return p ? p.before + p.word + p.after : null;
}
